<template>

    <f7-page hide-toolbar-on-scroll>

        <f7-block-title>{{name}}</f7-block-title>
<FullCalendar :events="events" />

        <f7-block>
            
        </f7-block>

    </f7-page>

</template>

<script>

    
    import IconHome from 'vue-material-design-icons/Home.vue'
    import IconCalendar from 'vue-material-design-icons/Calendar.vue'
    import IconTrashCan from 'vue-material-design-icons/TrashCan.vue'
    import IconEye from 'vue-material-design-icons/Eye.vue'
    
    import { FullCalendar } from 'vue-full-calendar'
    import 'fullcalendar/dist/fullcalendar.css'

    export default {

        name: "Calendar",
        components: {IconHome, IconCalendar, IconTrashCan, IconEye, FullCalendar},
        data() {
            return {
                name: 'Calendar',
                events: [
                  {
                      title  : 'event1',
                      start  : '2020-06-01',
                  },
                  {
                      title  : 'event2',
                      start  : '2020-06-05',
                      end    : '2020-06-07',
                  },
                  {
                      title  : 'event3',
                      start  : '2020-06-09T12:30:00',
                      allDay : false,
                  },
                ]
            };
        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/calendar.vue